<template>
  <div class="page-container">
    <Header />
    <h1 class="titles">Other work</h1>
    <div class="thumbnails-container">
      <div class="thumbnail" v-for="section in sections" :key="section.route" @click="$router.push({ name: section.route })">
        <video v-if="section.video" autoplay muted loop playsinline :poster="section.image" :aria-label="section.label">
          <source :src="section.video.webm" type="video/webm">
          <source :src="section.video.mp4" type="video/mp4">
        </video>
        <img v-else :src="section.image" :alt="section.label" />
        <p>{{ section.label }}</p>
      </div>
    </div>
    <SiteFooter />
  </div>
</template>

<script>
import Header from './header.vue';
import SiteFooter from '@/components/SiteFooter.vue';
import otherWork from '@/data/otherWork';

export default {
  name: 'OtherWork',
  components: { Header, SiteFooter },
  data() {
    return { sections: otherWork };
  }
}
</script>

<style scoped lang="scss">
@use '../assets/styles/global.scss' as *;

// Always 3 x 2 (2 x 3 on phones), so the six tiles never end up 5 + 1.
.thumbnails-container {
  display: grid;
  grid-template-columns: repeat(3, auto);
  justify-content: center;
  @media (max-width: 768px) {
    grid-template-columns: repeat(2, auto);
    .thumbnail {
      width: 150px;
      height: 220px;
    }
  }
}
.thumbnail {
  width: 170px;
  height: 250px;
  border-radius: 20px;
  overflow: hidden;
  text-align: center;
  margin: 10px;
  transition: transform 0.3s ease;
  cursor: pointer;
}
.thumbnail:hover {
  transform: scale(1.1);
}
.thumbnail img,
.thumbnail video {
  display: block;
  width: 100%;
  height: 80%;
  object-fit: cover;
}
.thumbnail p {
  margin: 10px 0 0 0;
  font-size: 16px;
  color: #333;
}
</style>
